var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.params.valueFormatted)?[(_vm.params.general)?_c('HbStatusGeneral',{staticClass:"mt-1",attrs:{"type":_vm.getStatus.type,"status":_vm.params.valueFormatted,"icon":_vm.getStatus.icon}}):_c('hb-status',{staticClass:"override-overflow",attrs:{"color":_vm.statusColor}},[_vm._v(" "+_vm._s(_vm.params.valueFormatted)+" ")])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }